"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectRenderer = void 0;
exports.ObjectControl = ObjectControl;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const core_1 = require("@jsonforms/core");
const react_2 = require("@jsonforms/react");
const lodash_isempty_1 = __importDefault(require("lodash.isempty"));
function ObjectControl({ renderers, cells, uischemas, schema, label, path, visible, enabled, uischema, rootSchema, }) {
    const detailUiSchema = (0, react_1.useMemo)(() => (0, core_1.findUISchema)(uischemas ?? [], schema, uischema.scope, path, () => (0, lodash_isempty_1.default)(path)
        ? core_1.Generate.uiSchema(schema, "VerticalLayout")
        : { ...core_1.Generate.uiSchema(schema, "Group"), label }, uischema, rootSchema), [uischemas, schema, path, label, uischema, rootSchema]);
    if (!visible) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(react_2.JsonFormsDispatch, { visible: visible, uischemas: uischemas, enabled: enabled, schema: schema, uischema: detailUiSchema, path: path, renderers: renderers, cells: cells }));
}
exports.ObjectRenderer = (0, react_2.withJsonFormsDetailProps)(ObjectControl);
